import { EnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { CartonsEffects } from './effects/cartons.effects';
import { CARTONS_FEATURE_KEY } from './keys';
import { cartonsReducer } from './reducers/cartons.reducer';

export function provideCartonsStore(): EnvironmentProviders[] {
    return [provideState(CARTONS_FEATURE_KEY, cartonsReducer), provideEffects(CartonsEffects)];
}
